var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component"},_vm._l((_vm.els),function(item,index){return _c(item.tag,{key:index,tag:"component",style:({ display: item.fullWidth ? 'block' : undefined })},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }